import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/transferencialog';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageTransferencias() {
  return (
    <Root title={PAGE_TITLE.TRANSFERENCIAS}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
